// Prev/next buttons for the photo card carousel. The track itself is a native scroller.
document.querySelectorAll<HTMLElement>('.carousel').forEach((section) => {
	const track = section.querySelector<HTMLElement>('.carousel__track');
	const prev = section.querySelector<HTMLButtonElement>('[data-carousel="prev"]');
	const next = section.querySelector<HTMLButtonElement>('[data-carousel="next"]');
	if (!track || !prev || !next) return;

	const step = () => {
		const card = track.querySelector<HTMLElement>('.carousel__card');
		const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
		return card ? card.offsetWidth + gap : track.clientWidth;
	};

	const update = () => {
		const max = track.scrollWidth - track.clientWidth - 1;
		prev.disabled = track.scrollLeft <= 0;
		next.disabled = track.scrollLeft >= max;
	};

	prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
	next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
	track.addEventListener('scroll', update, { passive: true });
	window.addEventListener('resize', update);
	update();
});
